import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

function EditAppGuide(props) {
  // Initialize state with default values for accountName, accountNo, and status
  const [id, setId] = useState(props?.item?.id);
  const [accountName, setAccountName] = useState(props?.item?.title);
  const [accountNo, setAccountNo] = useState(props?.item?.streaming_url);
  const [status, setstatus] = useState(props?.item?.status);
  const [preview, setPreview] = useState(null);
  const [thumbnail, setThumbnail] = useState(props?.item?.thumbnail);

  const [isLoading, setIsLoading] = useState(props.isLoading);
  // Handler functions for updating account information
  const handleAccountNameChange = (event) => {
    setAccountName(event.target.value);
  };

  const handleAccountNoChange = (event) => {
    setAccountNo(event.target.value);
  };

  const statusChange = (e) => {
    setstatus(e.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    let data = {
      title: accountName,
      streaming_url: accountNo,
      status: status,
      thumbnail: thumbnail,
    };
    props.onSubmit(data);
  };


  const handleLogoChange = (e) => {
    // setThumbnail(e.target.value);
    if (
      e.target.files[0].type === "image/jpeg" ||
      e.target.files[0].type === "image/png" ||
      e.target.files[0].type === "image/jpg"
    ) {
      let imgReview = e.target.files[0];
      console.log(imgReview);
      if (imgReview) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreview(reader.result);
        };
        reader.readAsDataURL(imgReview);
      } else {
        setPreview(null);
      }
      setThumbnail(e.target.files[0]);
    } else {
      alert("This is only accept image files! Thanks");
      setThumbnail(null);
      return;
    }
  };


  return (
    <Modal isOpen={true} toggle={props.onClose}>
      <ModalHeader toggle={props.onClose}>Edit App Guide </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="title">Title</Label>
            <Input
              type="text"
              name="title"
              id="title"
              value={accountName}
              onChange={handleAccountNameChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="description">URL</Label>
            <Input
              type="text"
              name="description"
              id="description"
              value={accountNo}
              onChange={handleAccountNoChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="logo">Logo</Label>
            <Input
              type="file"
              accept="image/png, image/gif, image/jpeg"
              name="logo"
              id="logo"
              onChange={handleLogoChange}
            />
          </FormGroup>
          {preview ? (
            <img
              src={preview}
              alt=""
              style={{ width: "100px", height: "100px" }}
            />
          ) : (
            <img
              src={thumbnail}
              alt=""
              style={{ width: "100px", height: "100px" }}
            />
          )}
          <FormGroup>
            <Label for="exampleSelect">Status</Label>
            <Input
              type="select"
              name="select"
              id="exampleSelect"
              value={status}
              onChange={statusChange}>
              <option value="active">Active</option>
              <option value="disable">Disabled</option>
            </Input>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-default" onClick={props.onClose}>
          No
        </button>
        {isLoading == false && (
          <button className="btn btn-success" onClick={handleSubmit}>
            Save
          </button>
        )}
        {isLoading == true && (
          <button className="btn btn-success" disabled="disabled">
            Uploading...
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default EditAppGuide;
